var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two"},[_c('nav-box'),_c('div',{staticStyle:{"height":"50px"}}),_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":"https://map.whzsh.com/"}}),_c('footerBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }